(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('PatientGroup', PatientGroup);

    PatientGroup.$inject = ['$resource'];

    function PatientGroup ($resource) {
        var resourceUrl =  'api/patient-groups/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getAllByClinic': { 'url': 'api/patient-groups/clinic/:id', method: 'GET', isArray: true}
        });
    }
})();
